import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  faTrashAlt,
  faCircleDot,
  faCircle,
  faLocationCheck,
} from "@fortawesome/pro-regular-svg-icons";

import { faTruck } from "@fortawesome/pro-solid-svg-icons";

import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import axiosConfig from "../../../services/Axios";
import { toast } from "react-toastify";
import AddressForm from "./AddressForm";
import Title from "../../../components/ui/Title";
import { useDispatch } from "react-redux";
import { fetchCountry } from "../../../features/country/countrySlice";
import PopoverMenu from "../../../components/ui/PopoverMenu";

function AddressList({ partner, setPartner }) {
  const [modalAddressFormIsOpen, setModalAddressFormIsOpen] = useState(false);
  const [partnerAddressSelected, setPartnerAddressSelected] = useState();
  const [displayed, setDisplayed] = useState(false);
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();

  useEffect(() => {
    fetchCountries();
  }, []);

  const fetchCountries = () => {
    let partnerClone = { ...partner };
    let partnerLogisticAddressesClone = [];
    partnerClone.partnerLogisticAddresses.map((partnerAddress) => {
      dispatch(fetchCountry(partnerAddress.country)).then((response) => {
        let country = response.payload;
        partnerAddress.country =
          i18n.language === "fr" ? country.labelFr : country.labelEn;

        partnerLogisticAddressesClone =
          partnerLogisticAddressesClone.concat(partnerAddress);
        setPartner({
          ...partnerClone,
          partnerLogisticAddresses: partnerLogisticAddressesClone,
        });
      });
    });
  };

  const handleDeleteAddress = (address) => {
    Swal.fire({
      text:
        t("global.form.delete") +
        " " +
        address.address +
        " à " +
        address.city +
        " ?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: t("global.btn.confirm_delete"),
      cancelButtonText: t("global.btn.cancel"),
      customClass: {
        actions: "gap-2 h-20",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        axiosConfig
          .delete(process.env.REACT_APP_API_URL + address["@id"])
          .then((response) => {
            if (response?.status === 204) {
              toast.success(t("partnerLogisticAddress.deleted"), {
                theme: "colored",
                hideProgressBar: true,
              });

              let newPartnerAddresss = partner.partnerLogisticAddresses.filter(
                (p) => p.id !== address.id
              );
              setPartner({
                ...partner,
                partnerLogisticAddresses: newPartnerAddresss,
              });
            }
          })
          .catch((e) => {
            toast.error(t("partnerLogisticAddress.deleted_error"), {
              theme: "colored",
              hideProgressBar: true,
            });
          });
      }
    });
  };

  const toggleMainAddress = async (address) => {
    try {
      await axiosConfig
        .patch(
          process.env.REACT_APP_API_URL + address["@id"],
          { main: true },
          {
            headers: { "Content-Type": "application/merge-patch+json" },
          }
        )
        .then((response) => {
          if (response?.status === 200 && response?.data) {
            let newPartnerAddresss = partner.partnerLogisticAddresses.map(
              (address) =>
                address.id === response.data.id
                  ? response.data
                  : { ...address, main: false }
            );
            setPartner({
              ...partner,
              partnerLogisticAddresses: newPartnerAddresss,
            });
          }
        });
    } catch (e) {
      if (e.response?.status !== 200 && e.response?.data["hydra:description"]) {
        toast.error(e.response?.data["hydra:description"]);
      }
    }
  };

  const openModalAddress = async (address = null) => {
    setPartnerAddressSelected(address);
    setModalAddressFormIsOpen(true);
  };

  useEffect(() => {
    if (modalAddressFormIsOpen === false) {
      setPartnerAddressSelected(null);
    }
  }, [partnerAddressSelected]);

  return (
    <div>
      <div className="lg:p-8 lg:px-10 mt-8 lg:bg-white rounded-lg">
        <Title
          icon={faLocationCheck}
          title={t("partnerLogisticAddress.logistic_adress")}
          button={{
            label: t("partnerLogisticAddress.create"),
            fn: () => openModalAddress(null),
          }}
        />

        <div className="bg-bioport-blue-light grid grid-cols-12 text-white font-bold px-4 p-3 text-xs lg:text-sm">
          <div className="col-span-5">
            {t("partnerLogisticAddress.address")}
          </div>
          <div className="col-span-3 text-center">
            {t("partnerLogisticAddress.dock-short")}
          </div>
          <div className="col-span-3 text-center">
            {t("partnerLogisticAddress.main_address")}
          </div>
          <div className="col-span-1 text-center"></div>
        </div>
        {partner.partnerLogisticAddresses.map((partnerAddress, key) => (
          <div
            key={key}
            className={`grid grid-cols-12 px-4 p-3 hover:bg-gray-50 text-xs lg:text-sm items-center ${
              key % 2 === 0 && "bg-gray-100"
            }`}
          >
            <div
              className="col-span-5"
              onMouseEnter={() => partnerAddress.comment && setDisplayed(true)}
              onMouseLeave={() => partnerAddress.comment && setDisplayed(false)}
            >
              <div>{partnerAddress.address}</div>
              {partnerAddress.addressComplement && (
                <div>{partnerAddress?.addressComplement}</div>
              )}
              <div>
                {partnerAddress.zipcode} {partnerAddress.city}
              </div>
              <div>{partnerAddress.country}</div>

              {displayed && (
                <div className="text-xs italic">{partnerAddress.comment}</div>
              )}
            </div>
            <div className="col-span-3 text-center">
              <FontAwesomeIcon
                icon={faTruck}
                className={`${
                  partnerAddress.dock ? "text-bioport-orange" : "text-gray-300"
                }`}
                title={t("partnerLogisticAddress.dock")}
              />
            </div>
            <div className="col-span-3 text-center">
              <FontAwesomeIcon
                icon={partnerAddress.main ? faCircleDot : faCircle}
                className="hover:scale-110 cursor-pointer"
                onClick={() => toggleMainAddress(partnerAddress)}
              />
            </div>
            <div className="col-span-1 text-center">
              <PopoverMenu
                links={[
                  {
                    link: () => openModalAddress(partnerAddress),
                    icon: faEdit,
                    label: t("global.edit"),
                    class:
                      "hover:cursor-pointer hover:underline text-bioport-blue mb-2",
                  },
                  {
                    link: () => handleDeleteAddress(partnerAddress),
                    icon: faTrashAlt,
                    label: t("global.form.delete"),
                    class: "hover:cursor-pointer hover:underline text-red-600",
                  },
                ]}
              />
            </div>
          </div>
        ))}
      </div>
      <AddressForm
        setIsOpen={setModalAddressFormIsOpen}
        modalIsOpen={modalAddressFormIsOpen}
        partnerAddressSelected={partnerAddressSelected}
        partner={partner}
        setPartner={setPartner}
      />
    </div>
  );
}

export default AddressList;
